import $ from 'jquery';
import Inputc from '../../../components/input.vue'
import {api,imgPath} from "../../../common/config";
import {store} from '../../../store/store.js'
import {StorageUtil, LocalStorageUtil} from '../../../common/Auth.js';
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {MD5Util} from '../../../common/MD5Util.js';
import {CommonUtil} from "../../../common/CommonUtil";

export default {
  name: 'activitydetails',
  data(){
    return {
      isOne: 0,
      last: 0,
      /*praiseCount: 300,//点赞数量*/
      key: '',
      idCard: '',
      idPasswordKey: '',
      idPassword: '',
      phone: '',
      dataInfo: null,
      isLogin: true,
      activityId: '',
      activityInfoData: {},
      user: null,
      isApply:false,//true,点击报名,
      libCode:'',
      opacType: store.opacType,
      applyTips:'',//提示语
      imgPath:imgPath,
    }
  },
  components: {
    Inputc,
  },
  beforeRouteLeave(to, from, next) {
    if($('#bdshare_weixin_qrcode_dialog')) {/*关闭分享组件微信分享页面*/
      $('#bdshare_weixin_qrcode_dialog').hide();
    }
    next()
  },
  beforeMount() {
    store.wrap.activeRouteName = '活动';
  },
  watch: {
     $route() {
        this.libCode=this.$route.query.hallCode || '';
        this.activityId = this.$route.query.activityId;
     }
  },
  mounted() {
       this.libCode=this.$route.query.hallCode || '';
       this.activityId = this.$route.query.activityId;
       this.queryinfo();
  },
  methods: {
    queryinfo(){
        this.user = {
            idCard: store.user ? store.user.idCard :"",
            cardName: store.user ? store.user.cardName :"",
            phone: store.user ? store.user.phone :"",
        };
        Promise.all([this.activityinfo()]).then(()=>{
            this.dataInfo = StorageUtil.getObject("activityInfo");
            let index = -1;
            for (let i = 0; i < this.dataInfo.ids.length; i++) {
                if (this.activityId === this.dataInfo.ids[i]) {
                    index = i;
                    break;
                }
            }
            if (index === 0 && this.dataInfo.pageNo === 1) {
                this.isOne = 1;
            }
            if (index === this.dataInfo.ids.length - 1 && this.dataInfo.pageNo === this.dataInfo.totalPage) {
                this.last = 1;
            }
            let contentBDS=this.activityInfoData.content?this.activityInfoData.content.replace(/<[^>]+>/g,"").replace(/&nbsp;/ig, ""):'';//去掉html标签和空格;
            if(contentBDS.length>50){
                contentBDS=contentBDS.substring(0,50);
            }
            window._bd_share_config = {
                share: [{
                    "tag": "share_1",
                    "bdSize": 16,
                }],
                common: {
                    bdText: '云图书馆 - ' + this.activityInfoData.title,
                    bdDesc: contentBDS,
                    bdPic:this.imgPath+this.activityInfoData.image|| "../../../assets/images/noimg.png",
                    bdUrl: this.activityInfoData.htmlUrl,
                    bdMini: 1,
                    bdMiniList: ['qzone', 'tsina', 'renren', 'douban']
                }
            };
            window._bd_share_main.init();
        })
    },
    praise(){
    },
    /**获取活动详情**/
    activityinfo(){
      return new Promise((resolve, reject)=>{
        let url = api.activity.info.replace('{activityId}', this.activityId).replace('{idCard}', this.user.idCard);
        ajaxUtil.ajaxJson(url, null, "GET", (data) => {
          this.activityInfoData = data;
          resolve()
        }, null, this);
      })
    },

    //活动报名
    toApply(activityId) {
      let _this = this;
      if (_this.isApply){
        return;
      }
      if(!store.user.idCard){
        store.index.$refs.login.showLogin();
        return;
      }
      _this.isApply=true;
      let url = api.activity.apply.replace('{activityId}', activityId).replace('{idCard}', _this.user.idCard);
      ajaxUtil.ajaxJson(url, null, 'GET', (data) => { //成功
        _this.activityInfoData.applyStatus = 1;
        _this.isApply=false;
      }, (result) => { //失败
        _this.isApply=false;
        if (result.errorCode ===30604) {
            _this.activityInfoData.applyStatus = 1;
        }else if (result.errorCode ===30606) {
            _this.activityInfoData.applyStatus = 3;
        }else if (result.errorCode ===30608){
            _this.activityInfoData.applyStatus = 5;
        }else if (result.errorCode ===30605){
              _this.activityInfoData.applyStatus = 2;
          }else if(result.errorCode === 2322){
            _this.activityInfoData.applyStatus==0;
            this.applyTips='你已入本馆黑名单，被限制该业务操作！';
            setTimeout(()=>{this.applyTips=''},2000)
        }
      }, _this);
    },
    success: function () {
      if (StorageUtil.getObject("user") != null) {
        this.isLogin = true;
        /*this.readerId = StorageUtil.getObject("user").readerId;*/
      }
    },


    //登陆
    login: function () {
      let _this = this;
      if (_this.key.length == 18) { //身份证
        _this.idCard = _this.key;
      } else { //手机号
        _this.phone = _this.key;
      }
      _this.idPassword = MD5Util.hex_md5(_this.idPasswordKey);

      let loginData = {
        idCard: _this.idCard,
        idPassword: _this.idPassword,
        phone: _this.phone
      };
      let url = api.reader.login;
      ajaxUtil.ajaxLogin(url, loginData, 'POST', (data) => { //成功
        StorageUtil.storeString("token", data.token);
        StorageUtil.storeObject("user", data);
        store.user = data;
        store.token = data.token;
        location.reload();
      }, (result) => { //失败
        _this.key = '';
        _this.idPasswordKey = '';
        _this.idPassword = '';
        _this.phone = '';
        _this.idCard = '';
      }, this);
    },


    queryData: function (activityId, isAdd) {
        let url = api.activity.info.replace('{activityId}',activityId).replace('{idCard}', this.user.idCard);
        ajaxUtil.ajaxJson(url, "", "GET", (data) => {
            this.activityInfoData = data;
            this.activityId=activityId;
            if (isAdd === 1) {
              StorageUtil.storeObject("activityInfo", this.dataInfo);
            }
            CommonUtil.mergeQueryClean(this,{"activityId": activityId,"libCode":this.$route.query.libCode});
          }, (result) => {
      }, this)
    },

    prev: function (activityId) {
      let index = -1;
      for (let i = 0; i < this.dataInfo.ids.length; i++) {
        if (activityId === this.dataInfo.ids[i]) {
          index = i;
          this.activityId = this.dataInfo.ids[i - 1];
          break;
        }
      }
      if (index !== -1 && index >= 0) {
        if (index === 0) { //上一页
          this.dataInfo.pageNo = this.dataInfo.pageNo - 1;
          this.paging(this.dataInfo.pageNo, 1, this.dataInfo.ids, index);
        } else {
          index = index - 1;
          let id = this.dataInfo.ids[index];
          this.queryData(id,0);
          CommonUtil.mergeQueryClean(this,
              {
                "activityId": id,
                "libCode":this.libCode
              });
          if (index === 0) {
            if (this.dataInfo.pageNo === 1) {
              this.isOne = 1;
              this.last = 0;
              return;
            }
          } else {
            this.last = 0;
            this.dataInfo.pageNo = (index + 1) % this.dataInfo.pageCount === 0 ? this.dataInfo.pageNo - 1 : this.dataInfo.pageNo;
            StorageUtil.storeObject("activityInfo", this.dataInfo);
          }
        }
      }
    },

    next: function (activityId) {
      let index = -1;
      for (let i = 0; i < this.dataInfo.ids.length; i++) {
        if (activityId === this.dataInfo.ids[i]) {
          index = i;
          this.activityId = this.dataInfo.ids[i + 1];
          break;
        }
      }
      if (index !== -1 && index >= 0) {
        if (index === this.dataInfo.ids.length - 1) { //翻页
          this.dataInfo.pageNo = this.dataInfo.pageNo + 1;
          this.paging(this.dataInfo.pageNo, 0, this.dataInfo.ids, index);
        } else {
          index = index + 1;
          let id = this.dataInfo.ids[index];
          this.queryData(id,0);
          CommonUtil.mergeQueryClean(this,{"activityId": id,"libCode":this.libCode});
          if (index === this.dataInfo.ids.length - 1) {
            if (this.dataInfo.pageNo === this.dataInfo.totalPage) {
              this.last = 1;
              this.isOne = 0;
              return;
            }
          } else {
            this.isOne = 0;
            this.dataInfo.pageNo = index % this.dataInfo.pageCount === 0 ? this.dataInfo.pageNo + 1 : this.dataInfo.pageNo;
            StorageUtil.storeObject("activityInfo", this.dataInfo);
          }
        }
      }
    },

    paging: async function (pageNo, findex, ids, index) {
      let arrId = [];
      let code = this.$route.query.code ||  store.chooseArea.code;
      let url;
      if (this.libCode!=null &&　this.libCode!==''){
          url = api.activity.activitys.replace('{libCode}',this.libCode).replace('{pageCount}', this.dataInfo.pageCount).replace('{pageNo}', this.dataInfo.pageNo).replace('{keyword}', "");
      }else {
          url = api.activity.search.replace('{locationCode}', code).replace('{pageCount}', this.dataInfo.pageCount).replace('{pageNo}', this.dataInfo.pageNo).replace('{keyword}', "");
      }
      await ajaxUtil.ajaxJson(url, '', 'get', (data) => {
        if (data.resultList != null) {
          for (let i = 0; i < data.resultList.length; i++) {
            arrId.push(data.resultList[i].id);
          }
        }
        let id;
        if (findex == 1) { //上一篇
          arrId = arrId.concat(ids);
          index = index + this.dataInfo.pageCount;
          id = arrId[index - 1];
          this.dataInfo.ids = arrId;
          this.queryData(id, 1);
        } else { //下一篇
          ids = ids.concat(arrId);
          id = ids[index + 1];
          this.dataInfo.ids = ids;
          this.queryData(id, 1);
        }
      }, null, this);
    },
  }
}
